export default __webpack_public_path__ + "static/media/character2Body.ef99b145.webp";